import { PropTypes } from "react"

const clientProfileDataPropTypes = {
    main: PropTypes.shape({
        clientType: PropTypes.string,
        clientNumber: PropTypes.string,
        name: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        legalForm: PropTypes.string,
        companyRegistrationNumber: PropTypes.string,
        dateOfBirth: PropTypes.string,
        mainAddress: PropTypes.shape({
            country: PropTypes.string,
            extension: PropTypes.string,
            locality: PropTypes.string,
            number: PropTypes.string,
            postalCode: PropTypes.string,
            street: PropTypes.string,
        }),
    }),
    detail: PropTypes.shape({
        correspondanceAddress: PropTypes.shape({
            country: PropTypes.string,
            extension: PropTypes.string,
            locality: PropTypes.string,
            number: PropTypes.string,
            postalCode: PropTypes.string,
            street: PropTypes.string,
        }),
        gender: PropTypes.string,
        language: PropTypes.string,
        emails: PropTypes.arrayOf(
            PropTypes.shape({
                email: PropTypes.string,
                default: PropTypes.string,
            })
        ),
        phoneNumbers: PropTypes.arrayOf(
            PropTypes.shape({
                default: PropTypes.string,
                mobile: PropTypes.string,
                number: PropTypes.string,
            })
        ),
        nationalIdNumber: PropTypes.string,
        title: PropTypes.string,
        nationality: PropTypes.string,
        birthCountry: PropTypes.string,
        birthPostalCode: PropTypes.string,
        birthLocality: PropTypes.string,
        maritalStatus: PropTypes.string,
        myEasinsure: PropTypes.string,
        profession: PropTypes.string,
        activSector: PropTypes.string,
        socialStatus: PropTypes.string,
        taxStatus: PropTypes.string,
        ppp: PropTypes.string,
        amlScore: PropTypes.string,
        amlProfile: PropTypes.string,
        licences: PropTypes.arrayOf(
            PropTypes.shape({
                licenceDate: PropTypes.string,
                licenceCategory: PropTypes.string,
            })
        ),
        accountNumbers: PropTypes.arrayOf(
            PropTypes.shape({
                IBAN: PropTypes.string,
                BIC: PropTypes.string,
            })
        ),
        contacts: PropTypes.arrayOf(
            PropTypes.shape({
                contactType: PropTypes.string,
                contactName: PropTypes.string,
                contactFirstName: PropTypes.string,
                contactNumber: PropTypes.string,
                contactdateOfBirth: PropTypes.string,
                contactgender: PropTypes.string,
            })
        ),
    }),
}

export default clientProfileDataPropTypes



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/clientProfileDataPropTypes.js